if (!window.DeskpadData) {
  window.DeskpadData = {};
}

//TODO: should be refactoed
const dpd = window.DeskpadData ? window.DeskpadData : {};
const dpc = window.DeskpadContent ? window.DeskpadContent : {};
const price = dpd.price ? dpd.price : {};
export const pricem2 = price.m2;
export const colorPrice = price.color;
export const radiusPrice = price.radius;
export const productId = dpd.productId;
export const canvasData = dpd.canvasData;
export const orderItemId = dpd.orderItemId;
export const faq = dpc.faq;
export const navigationBar = dpc.navigationBar;

export default window.DeskpadData;
